import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import WorkExperience from 'src/constants/workExperience';

interface EmployerExperiences {
    experience: Array<{
        code: WorkExperience;
        trKey: string;
    }>;
}

export default autoGeneratedReducer<Partial<EmployerExperiences>>({});
